import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const FAQCTA = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 via-teal-500 to-emerald-500">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full mb-6">
          <i className="ri-tools-line text-5xl text-white"></i>
        </div>
        
        <h2 className="text-4xl font-bold text-white mb-4 font-['Space_Grotesk']">
          {t('faq:cta.title')}
        </h2>
        
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed">
          {t('faq:cta.subtitle')}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/pdf-to-word"
            className="inline-flex items-center gap-2 bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-word-line text-2xl"></i>
            <span>{t('faq:cta.pdfToWord')}</span>
          </Link>
          
          <Link
            to="/pdf-to-excel"
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-file-excel-line text-2xl"></i>
            <span>{t('faq:cta.pdfToExcel')}</span>
          </Link>
          
          <Link
            to="/pdf-tools"
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-tools-line text-2xl"></i>
            <span>{t('faq:cta.allTools')}</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQCTA;